// extracted by mini-css-extract-plugin
module.exports = {"centerChild":"_2Lv8Xhb5FsI1vNkrNAgDQg=="};